import { Box } from "@mui/material";
import React from "react";
import { useState } from "react";
import PaymentMethodCashInModal from "./PaymentMethodCashInModal/PaymentMethodCashInModal";

const Billing = ({
  open2,
  route,
  getRefer,
  setOpen2,
  paymentInfo,
  setPaymentInfo,
  setCurrentCurrency,
  setCurrentAmount,
  currentCurrency,
  currentAmount,
  payAmoOn,
  receiver,
  pay_service_refer,
  setGetRefer,
  jobPage,
}) => {
  const [balanceDetails, setBalanceDetails] = useState({});
  const [inputField, setInputField] = useState({});
  const [selectedMethod, setSelectedMethod] = useState("");
  const [dueAmount, setDueAmount] = useState(0);

  const handleCurrentCurrencyChange = (e) => {
    setCurrentCurrency(e.target.value?.currency);
    setCurrentAmount(Math.ceil(e.target.value?.amount));
  };
  const handleClose2 = () => {
    setOpen2(false);
    setPaymentInfo({});
    setInputField({});
    setCurrentAmount("");
    setCurrentCurrency("");
  };
  return (
    <Box>
      <PaymentMethodCashInModal
        payAmoOn={payAmoOn}
        route={route}
        receiver={receiver}
        pay_service_refer={pay_service_refer}
        open2={open2}
        handleClose={handleClose2}
        setSelectedMethod={setSelectedMethod}
        selectedMethod={selectedMethod}
        getRefer={getRefer}
        setGetRefer={setGetRefer}
        dueAmount={dueAmount}
        currentCurrency={currentCurrency}
        setCurrentCurrency={setCurrentCurrency}
        currentAmount={currentAmount}
        setCurrentAmount={setCurrentAmount}
        paymentInfo={paymentInfo}
        handleCurrentCurrencyChange={handleCurrentCurrencyChange}
        jobPage={jobPage}
      />
    </Box>
  );
};

export default Billing;
